import React from 'react';
import './index.css'
import { Button } from 'react-bootstrap';
import Text from '../Text';

const MainButton = ({text, variant, disabled, rounded, size, marginVertical, marginRight, marginTop, type, _onClick, children}) => {
    let ownClass = rounded ?  ' btn-rounded ' : ''
    return (
        <Button 
            className={ownClass} 
            variant={variant} 
            disabled={disabled} 
            type={type}
            style={{margin: marginVertical ? '16px 0' : '0', marginRight: marginRight ? '16px' : '0', marginTop: marginTop ? '16px' : 0}}
            onClick={(e) => _onClick(e)}>
                <Text text={text} size={size ? size : 'little'}></Text>
                {children }
        </Button>
    )
}

export default MainButton;